module.exports = __webpack_public_path__ + "static/media/undraw_project_completed_w0oq.18d509cd.png";